// extracted by mini-css-extract-plugin
export default {"guestOrderContainer":"orderModalForm_guestOrderContainer__FNB8q","address":"orderModalForm_address__Q5qXv"};